import script from "./TimeOfDayScheduleComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeOfDayScheduleComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__